import { render, staticRenderFns } from "./SelfBurdenTemplate.vue?vue&type=template&id=e00f87ac&"
import script from "./SelfBurdenTemplate.vue?vue&type=script&lang=ts&"
export * from "./SelfBurdenTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports